let currentSignalRConnectionId = "";

export function setSignalRConnectionId(connectionId: string): void {
  currentSignalRConnectionId = connectionId;
}

export function getSignalRConnectionId(): string {
  return currentSignalRConnectionId;
}

export function clearSignalRConnectionId(): void {
  currentSignalRConnectionId = "";
}
